import React from "react";
const AddAnotherList = ({ title, items, renderItem, className = "" }) => {
  if (!items || items.length === 0) return null;
  return (
    <div className={`mt-8 border-t pt-6 ${className}`}>
      <h3 className="text-lg font-medium text-gray-900 mb-4">{title}</h3>
      <div className="space-y-3">
        {items.map((item, index) => (
          <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
            {renderItem(item, index)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddAnotherList;